import { gql } from '@efficiently/client-core-graphql-models';

export const PROJECT_DESIGN_CHANGES_PRESENCE = gql(`
	query ProjectDesignChangesPresence {
		projectDesignChanges {
			_id
		}
	}
`);
